import { useEffect, useState } from "react";

const useScrollPosition = (scrollContainerRef) => {
  const [hasScroll, setHasScroll] = useState(false);
  const [isScrolledTop, setIsScrolledTop] = useState(true);
  const [isScrolledBottom, setIsScrolledBottom] = useState(false);

  useEffect(() => {
    handleScroll();
  }, []);

  const handleScroll = () => {
    if (scrollContainerRef?.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;

      const isScrollable = scrollHeight > clientHeight;
      const scrolledTop = scrollTop < 10;
      const scrollBottom = scrollHeight - scrollTop - clientHeight < 10;

      setHasScroll(isScrollable);
      setIsScrolledTop(scrolledTop);
      setIsScrolledBottom(scrollBottom);
    }
  };

  return { hasScroll, isScrolledTop, isScrolledBottom, scrollContainerRef, handleScroll };
};

export default useScrollPosition;
